import React from 'react'

export const ModalFooter = ({ children }) => {
  return (
    <footer className="modal-card-foot">
      <div className="buttons">{children}</div>
    </footer>
  )
}
